export default __webpack_public_path__ + "static/media/BlueStars4.541f68a7.svg";